import { useState, useEffect } from 'react';

const useUserAgent = () => {
  const [userAgent, setUserAgent] = useState(null);

  useEffect(() => {
    if (navigator && navigator.userAgent) {
      setUserAgent(navigator.userAgent.toLowerCase());
    }
  }, []);

  return userAgent;
};

export const useIsFirefox = () => {
  const userAgent = useUserAgent();

  return userAgent && userAgent.includes('firefox');
};

export const useIsIE = () => {
  const userAgent = useUserAgent();

  return (
    (userAgent && userAgent.includes('MSIE')) ||
    (navigator && navigator.appVersion.indexOf('Trident/') > -1)
  );
};

export default useUserAgent;
